import { createAction } from 'redux-actions';

export const startResetPasswordSubmit = createAction('START_RESET_PASSWORD_SUBMIT');

export const resolveResetPasswordSubmit = createAction('RESOLVE_RESET_PASSWORD_SUBMIT');
